export default {
  isMobile(value) {
    return /^[1][3,4,5,6,7,8][0-9]{9}$/.test(value)
  },
  isNumber(value) {
    return /^[0-9]+$/.test(value)
    // return true
  },
  isPrice(value) {
    return /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value)
  }
}
